<script setup lang="ts">

</script>

<template>
  <interface-button class="auth-button">
    <slot />
  </interface-button>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.auth-button
  @apply bg-$global-blue-primary text-base font-medium px-3 py-2 rounded-lg
</style>
